import { observable, action, computed, toJS } from 'mobx'
import {
    ExternalData,
    ExternalGovPhoneData,
    ExternalGovPinData,
    ExternalCreditData
} from '../Model/ExternalData'
import DateTimeHelper from '../Helpers/DateTimeHelper'

export default class ExternalDataStore {

    @observable
    private cities: Array<object> = [
        { key: '2127', value: 'Agcabedii' },
        { key: '2632', value: 'Agdam/opt' },
        { key: '2023', value: 'Agdash/op' },
        { key: '2222', value: 'Agstafa/o' },
        { key: '2022', value: 'Agsu/opti' },
        { key: '2522', value: 'Astara/op' },
        { key: '36', value: 'Babek/opt' },
        { key: '0', value: 'Baku/opti' },
        { key: '2429', value: 'Balakan/o' },
        { key: '2020', value: 'Barda/opt' },
        { key: '2122', value: 'Beylaqan/' },
        { key: '2529', value: 'Bilasuvar' },
        { key: '2524', value: 'Calilabad' },
        { key: '36', value: 'Culfa/opt' },
        { key: '2221', value: 'Dashkasan' },
        { key: '2631', value: 'Fizuli/op' },
        { key: '2232', value: 'Gedabey/o' },
        { key: '2', value: 'Gancə/opt' },
        { key: '2224', value: 'Goranboy/' },
        { key: '2027', value: 'Goycay/op' },
        { key: '2220', value: 'Goygol/op' },
        { key: '2120', value: 'Hacıqabul' },
        { key: '2124', value: 'Imishli/o' },
        { key: '2028', value: 'İsmayıllı' },
        { key: '2025', value: 'Kyrdamir/' },
        { key: '2525', value: 'Lankaran/' },
        { key: '2527', value: 'Lerik/opt' },
        { key: '2521', value: 'Masallı/o' },
        { key: '2427', value: 'Mingechev' },
        { key: '2235', value: 'Naftalan/' },
        { key: '36', value: 'Nahchivan' },
        { key: '2126', value: 'Neftchala' },
        { key: '2421', value: 'Oguz/opti' },
        { key: '36', value: 'Ordubad/o' },
        { key: '2425', value: 'Qah/optio' },
        { key: '2229', value: 'Qazah/opt' },
        { key: '2420', value: 'Qabala/op' },
        { key: '2024', value: 'Qobustan/' },
        { key: '2333', value: 'Quba/opti' },
        { key: '2338', value: 'Qusar/opt' },
        { key: '2128', value: 'Saatlı/op' },
        { key: '2123', value: 'Sabirabad' },
        { key: '2335', value: 'Shabran/o' },
        { key: '36Sh', value: 'ahbuz/opt' },
        { key: '2026', value: 'Shamaxı/o' },
        { key: '2227', value: 'Samux/opt' },
        { key: '36', value: 'Sadarak/o' },
        { key: '2424', value: 'Sheki/opt' },
        { key: '2125', value: 'Salyan/op' },
        { key: '2230', value: 'Shəmkir/o' },
        { key: '36', value: 'Sharur/op' },
        { key: '2120', value: 'Shirvan/o' },
        { key: '2330', value: 'Siyazan/o' },
        { key: '1000', value: 'Sumqayıt/' },
        { key: '2223', value: 'Ter-Ter/o' },
        { key: '2231', value: 'Tovuz/opt' },
        { key: '2021', value: 'Ucar/opti' },
        { key: '2332', value: 'Xachmaz/o' },
        { key: '2331', value: 'Xızı/opti' },
        { key: '2520', value: 'Yardımlı/' },
        { key: '2233', value: 'Yevlax/op' },
        { key: '2422', value: 'Zaqatala/' },
        { key: '2029', value: 'Zardab/op' }
    ]

    @observable
    private data: ExternalData | null

    @observable
    private clientGovDataByPhones: Array<ExternalGovPhoneData> = []

    // @observable
    // private externalGovPhoneData: ExternalGovPhoneData | null

    // @observable
    // private externalGovPINData: ExternalGovPhoneData | null

    @observable
    private externalGovPinData: ExternalGovPinData | null

    @action.bound
    setClientGovDataByPin(data: ExternalGovPinData | null): void {
        this.externalGovPinData = data
    }

    @computed
    get getClientGovDataByPin(): ExternalGovPinData | null {
        return this.externalGovPinData
    }

    @observable
    isError: boolean = false

    private static _instance: ExternalDataStore

    public static getInstance(): ExternalDataStore {
        return this._instance || (this._instance = new this())
    }

    @action.bound
    pushData(creditInfoItem: ExternalCreditData | null): void {
        if (!creditInfoItem) {
            return
        }

        if (!this.data) {
            this.data = new ExternalData()
        }

        creditInfoItem.client.birthday = DateTimeHelper.formatDateForList(creditInfoItem.client.birthday)

        let newData = new ExternalData()
        newData.creditInfoItems = toJS(this.data.creditInfoItems)

        if ((creditInfoItem.creditNumber.toString() === '0' && creditInfoItem.creditStatus.toString() !== 'Accepted')
            || newData.creditInfoItems
                .map(x => x.creditNumber)
                .filter(x => x === creditInfoItem.creditNumber).length === 0) {
            newData.creditInfoItems.push(creditInfoItem)
            this.data = newData
        }
    }

    @action.bound
    setData(data: ExternalData | null): void {

        if (data) {
            data!.creditInfoItems = data!.creditInfoItems.map((x) => {
                x.client.birthday = DateTimeHelper.formatDateForList(x.client.birthday)
                return x
            })
        }

        this.data = data
    }

    @computed
    get getExternalPhoneData(): ExternalData | null {
        return this.data
    }

    @computed
    get getData(): ExternalData | null {
        return this.data
    }

    @action.bound
    clearClientGovDataByPhones() {
        this.clientGovDataByPhones = []
    }
    @action.bound
    pushClientGovDataByPhones(phoneData: ExternalGovPhoneData) {
        this.clientGovDataByPhones.push(phoneData)
    }
    @computed
    get getClientGovDataByPhones(): Array<ExternalGovPhoneData> {
        return this.clientGovDataByPhones
    }

    @computed
    get getExternalGovPhonesData(): Array<ExternalGovPhoneData> {
        return this.clientGovDataByPhones
    }

    @action.bound
    clearCities() {
        this.cities = []
    }
    @action.bound
    setCities(cities: Array<Object>) {
        this.cities = cities
    }
    @computed
    get getCities(): Array<object> {
        return this.cities
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Stores/ExternalDataStore.ts